<div class="column-filter-dropdown" #dropdownContainer>
  <!-- Dropdown Menu -->
  <div class="dropdown-menu" #dropdownMenu>
    <!-- Sort Section -->
    <div class="sort-section">
      <div class="section-title">Sort</div>
      <div class="sort-options">
        <button 
          type="button"
          class="sort-option"
          [class.active]="sortDirection === 'asc'"
          (click)="onSortAscending()"
          [attr.aria-label]="'Sort A to Z'">
          <i class="bi bi-sort-alpha-down"></i>
          <span>Sort A to Z</span>
        </button>
        <button 
          type="button"
          class="sort-option"
          [class.active]="sortDirection === 'desc'"
          (click)="onSortDescending()"
          [attr.aria-label]="'Sort Z to A'">
          <i class="bi bi-sort-alpha-up"></i>
          <span>Sort Z to A</span>
        </button>
      </div>
    </div>

    <!-- Divider -->
    <div class="divider"></div>

    <!-- Filter Section -->
    <div class="filter-section">
      <div class="section-title">{{ column.header }}</div>
      
      <!-- Operator Dropdown -->
      <div class="operator-select">
        <label class="operator-label">Condition</label>
        <select 
          class="operator-dropdown"
          [(ngModel)]="selectedOperator"
          (ngModelChange)="onOperatorChange($event)"
          [attr.aria-label]="'Filter condition'">
          <option *ngFor="let op of availableOperators" [ngValue]="op">
            {{ getOperatorLabel(op) }}
          </option>
        </select>
      </div>

      <!-- Value Inputs -->
      <div class="value-inputs">
        <!-- Multi-Select for Badge/Select types -->
        <div *ngIf="needsMultiSelect()" class="multi-select-wrapper">
          <app-multi-select-filter
            [options]="uniqueValues"
            [selectedValues]="tempFilterValues"
            [placeholder]="''"
            [searchable]="false"
            (selectionChange)="onMultiSelectChange($event)">
          </app-multi-select-filter>
        </div>

        <!-- Single Text Input -->
        <div *ngIf="needsSingleInput() && (column.type === 'text' || column.type === 'link')" class="text-input-wrapper">
          <input 
            type="text"
            class="filter-input"
            [value]="textInputValue"
            (input)="onTextInputChange($any($event.target).value)"
            [placeholder]="'Enter value...'"
            [attr.aria-label]="'Filter value'">
        </div>

        <!-- Single Number Input -->
        <div *ngIf="needsSingleInput() && column.type === 'number'" class="number-input-wrapper">
          <input 
            type="number"
            class="filter-input"
            [value]="numberInputValue || ''"
            (input)="onNumberInputChange($any($event.target).value)"
            [placeholder]="'Enter number...'"
            [attr.aria-label]="'Filter value'">
        </div>

        <!-- Single Date Input -->
        <div *ngIf="needsSingleInput() && column.type === 'date'" class="date-input-wrapper">
          <input 
            type="date"
            class="filter-input"
            [value]="formatDateForInput(dateInputValue)"
            (change)="onDateInputChange($any($event.target).value)"
            [attr.aria-label]="'Filter date'">
        </div>

        <!-- Number Range Inputs -->
        <div *ngIf="needsRangeInput() && column.type === 'number'" class="range-inputs">
          <input 
            type="number"
            class="filter-input range-input"
            [value]="numberMinValue || ''"
            (input)="onNumberMinChange($any($event.target).value)"
            placeholder="Min"
            [attr.aria-label]="'Minimum value'">
          <span class="range-separator">to</span>
          <input 
            type="number"
            class="filter-input range-input"
            [value]="numberMaxValue || ''"
            (input)="onNumberMaxChange($any($event.target).value)"
            placeholder="Max"
            [attr.aria-label]="'Maximum value'">
        </div>

        <!-- Date Range Inputs -->
        <div *ngIf="needsRangeInput() && column.type === 'date'" class="range-inputs">
          <input 
            type="date"
            class="filter-input range-input"
            [value]="formatDateForInput(dateFromValue)"
            (change)="onDateFromChange($any($event.target).value)"
            [attr.aria-label]="'From date'">
          <span class="range-separator">to</span>
          <input 
            type="date"
            class="filter-input range-input"
            [value]="formatDateForInput(dateToValue)"
            (change)="onDateToChange($any($event.target).value)"
            [attr.aria-label]="'To date'">
        </div>

        <!-- Date Preset (Today, This Week, This Month) -->
        <div *ngIf="needsDatePreset()" class="date-preset">
          <span class="preset-label">{{ getOperatorLabel(selectedOperator!) }}</span>
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <button 
        type="button"
        class="apply-btn"
        (click)="onApplyFilter()"
        [attr.aria-label]="'Apply filter'">
        Apply
      </button>
      <button 
        type="button"
        class="clear-btn"
        (click)="onClearFilter()"
        [attr.aria-label]="'Clear filter'">
        Clear
      </button>
    </div>
  </div>
</div>

